import * as cart from '@shopify/theme-cart'
import m from 'mithril'
import stream from 'mithril/stream'

let states = stream({
  itemCount: 0,
  items: [],
  subtotal: 0,
  total: 0,
  initialised: false,
  visible: false,
  prescriptionStep: 0, // 0 hidden, 1 select options, 2 enter details,
  prescriptionDetails: {
    sphereLeft: null,
    sphereRight: null,
    cylinderLeft: null,
    cylinderRight: null,
    axisLeft: null,
    axisRight: null,
    pupillaryDistanceLeft: null,
    pupillaryDistanceRight: null
  },
  prescriptionValidity: false,
  selectedOption: null,
  isPolarised: false
})

window.showCart = function() {
  updateCartState({ initialised: true, visible: true });
}

window.closeCart = function() {
  updateCartState({ initialised: true, visible: false });
}

let events = {
  initCart: () => {
    updateCartState({ initialised: true })
  },
  addCartItem: id => {
    let { prescriptionDetails, isPolarised, prescriptionValidity } = states()
    let properties = {}

    if (prescriptionValidity) {
      Object.assign(properties, {
        ['Polarised'] : isPolarised ? 'Yes' : 'No',
        ['Axis (AXI) left'] : prescriptionDetails.axisLeft,
        ['Axis (AXI) right'] : prescriptionDetails.axisRight,
        ['Cylinder (CYL) left'] : prescriptionDetails.cylinderLeft,
        ['Cylinder (CYL) right'] : prescriptionDetails.cylinderRight,
        ['Pupillary Distance (PD) left'] : prescriptionDetails.pupillaryDistanceLeft,
        ['Pupillary Distance (PD) right'] : prescriptionDetails.pupillaryDistanceRight,
        ['Sphere (SPH) left'] : prescriptionDetails.sphereLeft,
        ['Sphere (SPH) right'] : prescriptionDetails.sphereRight
      })
    }

    cart.addItem(id, { quantity: 1, properties: properties }).then(() => {
      updateCartState({
        visible: true,
        prescriptionStep: 0,
        selectedOption: null,
        isPolarised: false
      })

      if (prescriptionDetails) {
        cart.updateNote(JSON.stringify(prescriptionDetails))
          .catch(error => console.error(error))
      }
    }).catch(error => console.error(error))
  },
  removeCartItem: (key) => {
    cart.removeItem(key).then(() => updateCartState())
      .catch(error => console.error(error))
  },
  updateCartItem: (key, options) => {
    cart.updateItem(key, options).then(() => updateCartState())
      .catch(error => console.error(error))
  },
  toggleCartVisibility: () => {
    states({ ...states(), visible: !states().visible })
  },
  togglePolarised: () => {
    states({ ...states(), isPolarised: !states().isPolarised })
  },
  setPrescriptionStep: (step) => {
    states({ ...states(), prescriptionStep: step })
  },
  setPrescriptionDetailValue: (name, value) => {
    let prescriptionDetails = states().prescriptionDetails
    prescriptionDetails[name] = value
    states({ ...states(), prescriptionDetails })
  },
  testPrescriptionValidity: () => {
    let { prescriptionDetails, prescriptionValidity } = states()
    for (let key in prescriptionDetails) {
      let value = prescriptionDetails[key]
      if (!value) {
        // Extra verification measure in case the browser ignores the disabled attribute
        // on the default option element
        if (prescriptionValidity) {
          states({ ...states(), prescriptionValidity: false })
        }
        return
      }
    }
    states({ ...states(), prescriptionValidity: true })
  },
  setSelectedOption: option => {
    states({ ...states(), selectedOption: option })
  }
}

function updateCartState(options = {}) {
  cart.getState().then(state => {
    const { items_subtotal_price, item_count, items } = state

    states({
      ...states(),
      ...options,
      items,
      itemCount: item_count,
      subtotal: items_subtotal_price
    })

    m.redraw()

    let hasPrescriptionItem = items.find(item => {
      return item.product_type === 'Prescription Sunglasses' // Has to match type given in Shopify
    })

    if (!hasPrescriptionItem) {
      cart.updateNote('')
        .catch(error => console.error(error))
    }
  }).catch(error => console.error(error))
}

events.initCart()

export {
  events,
  states
}
